{
	"name": "@cloudillo/scanillo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Scanillo document scanner app",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"ts": "tsgo --noEmit",
		"ts-test": "tsgo --noEmit -p tsconfig.test.json",
		"ts-watch": "tsgo --noEmit --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"test": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest",
		"test:watch": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest --watch",
		"test:coverage": "cross-env NODE_OPTIONS=\"--experimental-vm-modules\" jest --coverage",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Szilárd Hajba <szilu@cloudillo.org",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/core": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@cloudillo/rtdb": "workspace:^",
		"@jest/globals": "^30.5.2",
		"@symbion/opalui": "^0.16.0",
		"@testing-library/dom": "^10.4.2",
		"@testing-library/react": "^16.3.3",
		"@types/jest": "^30.0.0",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"@typescript/native": "npm:typescript@^7.0.2",
		"cross-env": "^10.1.0",
		"esbuild": "^0.28.2",
		"jest": "^30.5.2",
		"jest-environment-jsdom": "^30.5.2",
		"jscanify": "^1.4.3",
		"pdf-lib": "^1.17.1",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-icons": "^5.7.0",
		"react-router-dom": "^7.18.4",
		"rimraf": "^6.1.3",
		"ts-jest": "^29.4.15",
		"tslib": "^2.8.1",
		"typescript": "npm:@typescript/typescript6@^6.0.2"
	}
}
